import { api } from '@/utils/api';

type BulletinTargetDataDetail = {
  targetId: string;
  targetName?: string;
};

type BulletinTargetData = {
  targetType: number;
  data?: BulletinTargetDataDetail[];
};

export type Bulletin = {
  id: number;
  categoryId: number;
  categoryName: string;
  title: string;
  content: string;
  pin: boolean;
  isNew: boolean;
  isRead?: boolean;
  isTargeted?: boolean;
  targetData?: BulletinTargetData[];
  displayStartAt: string;
  createdAt: string;
  modifiedAt: string;
};

type BannerResponse = {
  code: string;
  data?: Bulletin;
};

// 라운지 api에서 문제 발생해도 파트너센터는 동작하도록 별도로 에러 처리
export const getBanner = async () => {
  try {
    return await api<BannerResponse>('get', `/api/public/bulletin/banner`, {
      serviceType: 'KAKAOWALLET'
    });
  } catch {
    return undefined;
  }
};
